import { MarketingPageHeader } from '../Header/MarketingPageHeader';
import { Footer } from '../Landing/LandingFooter';
import { LandingHelp } from '../Landing/LandingHelp';
import { HowLimitOrdersWorkSection } from './HowLimitOrdersWorkSection';
import { LimitOrdersBenefitsSection } from './LimitOrdersBenefitsSection';
import { LimitOrdersHero } from './LimitOrdersHero';
import { MovingMarketSection } from './MovingMarketSection';
import { SetPriceTimeSection } from './SetPriceTimeSection';
import { TradersControlSection } from './TradersControlSection';

export function LimitOrders() {
  return (
    <>
      <MarketingPageHeader />
      <LimitOrdersHero />
      <main className="mx-4.5 tablet:mx-11 desktop:mx-auto desktop:p-4 py-0" data-lock-theme="true">
        <SetPriceTimeSection />
        <TradersControlSection />
        <LimitOrdersBenefitsSection />
        <HowLimitOrdersWorkSection />
        <MovingMarketSection />
        <LandingHelp />
      </main>
      <Footer />
    </>
  );
}
